import TopTicker from './components/TopTicker';
import StickyHeader from './components/StickyHeader';
import UpdateRail from './components/UpdateRail';
import FeedGrid from './components/FeedGrid';
import CompareSection from './components/CompareSection';
import CollectionStrip from './components/CollectionStrip';
import RankSection from './components/RankSection';
import TimelineSection from './components/TimelineSection';
import DiscussionSection from './components/DiscussionSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div id="top" className="flex min-h-screen w-full flex-col bg-background-50 font-sans text-foreground-900">
      <TopTicker />
      <StickyHeader />
      <main className="flex-1">
        <UpdateRail />
        <FeedGrid />
        <CompareSection />
        <CollectionStrip />
        <RankSection />
        <TimelineSection />
        <DiscussionSection />
      </main>
      <Footer />
    </div>
  );
}